import { render, staticRenderFns } from "./proIndex.vue?vue&type=template&id=67839c0a&scoped=true"
import script from "./proIndex.vue?vue&type=script&lang=js"
export * from "./proIndex.vue?vue&type=script&lang=js"
import style0 from "./proIndex.vue?vue&type=style&index=0&id=67839c0a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67839c0a",
  null
  
)

export default component.exports